module.exports = __webpack_public_path__ + "img/spa-wellness.10cf25ef.svg";